import { forwardRef, useCallback, useImperativeHandle } from "react";
import { EQuestionCategory } from "common/enums/Project/Config/Vote/EQuestionCategory";
import { useProjectContext } from "components/pages/FeaturedProjects/contexts/Project";
import { useVote } from "hooks/useVote";
import VoteCard from "../../Votes/VoteCard";
import { EVoteCardModal, useVoteCardModal } from "../../Votes/VoteCardModal";
import CreateVoteModal from "../../Votes/VoteCardModal/CreateVoteModal";
import DeleteVoteModal from "../../Votes/VoteCardModal/DeleteVoteModal";
import classes from "./classes.module.scss";
import EditVoteModal from "../../Votes/VoteCardModal/EditVoteModal";

type IProps = {};

export const CastingVote = forwardRef<{ onOpenCreateModal: () => void }, IProps>((_props, ref) => {
	const { project } = useProjectContext();
	const { castingVotes, fetchCastingVotes } = useVote(project);
	const { isModalOpen, onCloseModal, onOpenCreateModal, onOpenDeleteModal, selectedVote, onOpenEditModal } = useVoteCardModal();

	useImperativeHandle(ref, () => ({
		onOpenCreateModal,
	}));

	const onCreated = useCallback(() => {
		fetchCastingVotes();
		onCloseModal();
	}, [fetchCastingVotes, onCloseModal]);

	const onEdited = useCallback(() => {
		fetchCastingVotes();
		onCloseModal();
	}, [fetchCastingVotes, onCloseModal]);

	const onDeleted = useCallback(() => {
		fetchCastingVotes();
		onCloseModal();
	}, [onCloseModal, fetchCastingVotes]);

	return (
		<div className={classes["root"]}>
			<div className={classes["votes-container"]}>
				{castingVotes.map((voteWithResults) => (
					<VoteCard
						key={voteWithResults.question.id}
						voteWithResults={voteWithResults}
						onDeleteClick={() => onOpenDeleteModal(voteWithResults.question)}
						onEditClick={() => onOpenEditModal(voteWithResults.question)}
					/>
				))}
			</div>

			{isModalOpen(EVoteCardModal.CREATE) && <CreateVoteModal category={EQuestionCategory.CASTING} onCreated={onCreated} onClose={onCloseModal} />}
			{isModalOpen(EVoteCardModal.EDIT) && selectedVote && <EditVoteModal vote={selectedVote} onEdited={onEdited} onClose={onCloseModal} />}
			{isModalOpen(EVoteCardModal.DELETE) && selectedVote && <DeleteVoteModal vote={selectedVote} onDelete={onDeleted} onClose={onCloseModal} />}
		</div>
	);
});
